export const DefaultNotificationPermission = "default";
export const DeniedNotificationPermission = "denied";
export const GrantedNotificationPermission = "granted";
